import React, { createContext, useContext, useEffect, useState } from "react";
import configApi from "@/api/configApi";

const initialState = {
  config: null,
  setConfig: (newConf) => null,
};
const ConfigContext = createContext(initialState);

const ConfigProvider = (props) => {
  const [config, setConfig] = useState();

  const getConfig = async () => {
    const { data } = await configApi.getConfig();

    setConfig(data);
  };

  useEffect(() => {
    getConfig();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ConfigContext.Provider value={{ config: config, setConfig: setConfig }}>
      {props.children}
    </ConfigContext.Provider>
  );
};

const useConfig = () => {
  const context = useContext(ConfigContext);
  if (!context) {
    throw new Error("useConfig doit être utilisé dans un ConfigProvider");
  }
  return context;
};

export { ConfigContext, ConfigProvider, useConfig };
